//@flow
// Externals
import React from "react";
import { useEffect, useRef } from "react";

// Styles
// $FlowFixMe
import "./TextInput.scss";

/*::
type Props = {
	value: string,
	placeholder: string,
	setStateValue: function,
	questionNumber: string,
	type: string,
	min: number,
	max: number,
	pattern: Regex,
	step: number
}
*/
const TextInput = (props /*: Props */) /*: any */ => {
	const { questionNumber } = props;
	const ref = useRef();

	useEffect(() => {
	}, [ref, questionNumber]);

	const handleAnswerChange = (event) => {
		let keyValue = event.charCode || event.keyCod;
		if (keyValue === 13) {
			event.preventDefault();
			document.activeElement.blur();
		}
	};
	const onInputDidChange = (e) => {
		props.setStateValue(e.target.value);
	};

	const input = (
		<input
			ref={ref}
			data-cy={"input-q" + props.questionNumber}
			type={props.type}
			value={props.value}
			placeholder={props.placeholder}
			min={props.min}
			max={props.max}
			name={props.type}
			pattern={props.pattern}
			step={props.step}
			onChange={(e) => {
				onInputDidChange(e);
			}}
			onKeyPress={(event) => handleAnswerChange(event)}
		/>
	);
	return <div className="text-input"> {input} </div>;
};

// Exports
export default TextInput;
